<template>
  <div>
    <div>
      <div class="white-background list-top-margin">
        <!-- 面包屑导航 -->
        <div class="page-top">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>系统配置</el-breadcrumb-item>
            <el-breadcrumb-item>
              <span style="color:#000;font-weight:bold;">部门</span>
            </el-breadcrumb-item>
          </el-breadcrumb>
        </div>

        <!-- 搜索筛选 -->
        <el-form :model="form" class="user-search" label-width="110px" size="small">
          <el-row>
            <el-col :span="7">
              <el-form-item label="部门编码">
                <el-input size="small" v-model="form.condition.departmentCode" placeholder="请输入部门编码" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="部门名称">
                <el-input size="small" v-model="form.condition.departmentName" placeholder="请输入部门名称" clearable></el-input>
              </el-form-item>
            </el-col>


            <el-col :span="3">
              <el-form-item label-width="20px">
                  <el-button size="small" type="primary" icon="el-icon-search" @click="search">查询</el-button>
              </el-form-item>
            </el-col>
          </el-row>

        </el-form>
      </div>

      <div class="white-background">
          <el-row class="tbl-btn">
            <el-col :span="12" class="tbl-btn-left">
              <el-button size="small" type="primary" icon="el-icon-plus" @click="createDept">创建部门</el-button>
            </el-col>
            <!-- <el-col :span="12" class="tbl-btn-right">
              <el-button type="default" size="small" icon="el-icon-s-operation">列配置</el-button>
            </el-col> -->
          </el-row>
          <!--列表-->
          <el-table
            size="small"
            :data="listData"
            highlight-current-row
            v-loading="loading"
            stripe
            border
            :header-cell-style="_headerStyle"
            element-loading-text="加载中"
            style="width: 100%;"
            @selection-change="handleTblSelectionChange"
            row-key="_id"
          >
            <el-table-column align="left" type="selection" width="60" :reserve-selection="true"></el-table-column>
            <el-table-column align="left" type="index" width="50" label="序号"></el-table-column>
            <el-table-column sortable label="部门编码" prop="departmentCode" >
              <!-- <template slot-scope="scope">
                <el-tooltip :content="scope.row.name1" placement="top">
                  <span class="txt-overflow">{{scope.row.name1}}</span>
                </el-tooltip>
              </template> -->
            </el-table-column>
            <el-table-column label="部门名称" sortable  prop="departmentName" >
            </el-table-column>

            <el-table-column prop="creater" label="创建人" ></el-table-column>

            <el-table-column prop="createTime" label="创建时间" sortable></el-table-column>
             <el-table-column prop="updater" label="更新人" ></el-table-column>
            <el-table-column prop="updateTime" label="更新时间" sortable></el-table-column>

            <el-table-column align="left" label="操作" min-width="50" fixed="right">
              <template slot-scope="scope">
                <el-tooltip content="编辑">
                  <el-button
                    type="primary"
                    size="mini"
                    icon="el-icon-edit"
                    circle
                    @click="handleEdit(scope.$index, scope.row)"
                  ></el-button>
                </el-tooltip>


                <el-tooltip content="删除">
                  <el-popconfirm title="确认删除？" @confirm="deleteUser(scope.$index, scope.row)">
                      <el-button
                          size="mini"
                          type="danger"
                          icon="el-icon-delete"
                          circle
                          slot="reference"
                      ></el-button>
                  </el-popconfirm>

                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页组件 -->
          <Pagination v-bind:child-msg="pageparm" @callFather="callFather" class="tbl-pagination"></Pagination>
        </div>
        <createDept :diaVisible="createProductPanVisible" :rowData="row"  @save="deptSava"></createDept>
      </div>
  </div>
</template>
<script>
import Pagination from "@/components/Pagination";
import createDept from '@/views/systemSetting/deptSys/createDept';
import { queryDeptList,delDeptById,addUptDept} from '@/api/business';

export default {
  name: "deptSys",
  components:{
      Pagination,
      createDept,
  },
  data() {
    return {
      form: {
        "condition": {
          "departmentCode": "",
          "departmentName": "",
          "factoryId":""
        },
        "currentPage": 1,
        "pageSize": 10
      },
      row:{},
      listData: [],
      loading: false,
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      createProductPanVisible:false,
      user:JSON.parse(window.localStorage.getItem('userdata')),

    };
  },
  created() {

    this.form['condition']['factoryId'] = this.user['factoryId'];

    this.getList();
  },
  methods: {
    getList(){
      queryDeptList(this.form).then(res=>{
        if(res['code'] == 200){

          this.pageparm = res["data"];
          this.listData = res['data']['list'];
        }else{
          this.$message.error(res['msg'] || '查询失败！');
        }
      })
    },
    search() {
      this.form['currentPage'] = 1;
      this.form['pageSize'] = 10;
      this.getList();
    },
    /**
     * 监听表格选中项变化事件
     */
    handleTblSelectionChange(val) {
      this.tblSelectionList = val;
    },
     // 分页插件事件
    callFather(param) {

      this.form['currentPage'] = param['currentPage'];
      this.form['pageSize'] = param['pageSize'];
      this.getList();
    },
    createDept(){
        this.row={};
        this.createProductPanVisible = true;
    },
    deptSava(val){
        if(val){
          val['factoryId'] = this.user['factoryId'];
          if(!val['updater']){
            val['creater'] =this.user['name'] + '(' + this.user['account'] + ')';

          }
          val['updater'] = this.user['name'] + '(' + this.user['account'] + ')';
          addUptDept(val).then(res=>{

            this.createProductPanVisible =false;
            if(res['code']==200){
              this.$message({
                type: 'success',
                message: '操作成功！'
              });
            }else{
              this.$message.error(res['msg'] || '操作失败！');
            }
            this.search();

          })
        }

    },
    handleEdit(index,row){
        this.row = row;
        this.createProductPanVisible = true;
    },
    deleteUser(index,row){
        delDeptById(row['_id']).then(res=>{
          if(res['code'] == 200){
              this.$message({
                type: 'success',
                message: '操作成功！'
              });
          }else{
              this.$message.error(res['msg'] || '操作失败！');
          }
          this.search();
        })
    }

  }
};
</script>
<style scoped>
.page-top {
  height: 30px;
  line-height: 30px;
}
.el-breadcrumb {
  line-height: 15px;
}
.page-row {
  /* background-color: #efefef; */
}
.page-row .el-tabs__nav-wrap::after {
  height: 0px;
}
.page-row .el-tabs__header {
  margin: 0px;
}

.user-search {
  margin-top: 20px;
}

.el-divider__text {
  padding: 0px 0px;
  font-size: 20px;
  cursor: pointer;
}
.tbl-pagination {
  text-align: right;
}
.tbl-btn {
  width: 100%;
  height: 40px;
  line-height: 40px;
}
.tbl-btn .tbl-btn-right {
  text-align: right;
}
.el-divider--horizontal {
  margin: 10px 0px;
}
.el-form-item {
  margin-bottom: 20px;
}
.search-row .half-width {
  width: calc(100% - 132px);
  margin-left: 8px;
}
.search-row .input-number {
  width: calc(50% - 5px);
}
</style>



// WEBPACK FOOTER //
// src/views/systemSetting/deptSys/deptSys.vue